<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.rc_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="rc_emname">
            <label class="weui-form-preview__label">{{customLabel.rc_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.rc_emname}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="rc_department">
            <label class="weui-form-preview__label">{{customLabel.rc_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rc_apply_start">
            <label class="weui-form-preview__label">{{customLabel.rc_apply_start || "补班时间（起）"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_apply_start}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rc_apply_end">
            <label class="weui-form-preview__label">{{customLabel.rc_apply_end || "补班时间（止）"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_apply_end}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rc_work_start">
            <label class="weui-form-preview__label">{{customLabel.rc_work_start || "上班时间（起）"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_work_start}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rc_work_end">
            <label class="weui-form-preview__label">{{customLabel.rc_work_end || "上班时间（止）"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_work_end}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rc_apply_count"> 
            <label class="weui-form-preview__label">{{customLabel.rc_apply_count || "补班时长"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_apply_count}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rc_work_count"> 
            <label class="weui-form-preview__label">{{customLabel.rc_work_count || "实际上班时长"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_work_count}}</span>
          </div>
          <div class="weui-form-preview__item" slot="rc_remark"> 
            <label class="weui-form-preview__label">{{customLabel.rc_remark || "补班理由"}}</label>
            <span class="weui-form-preview__value">{{form.main.rc_remark}}</span>
          </div>
        </custom-layout>
      </div>


      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.rcd_detno }}</div>
          <div>
            <div class="weui-form-preview__item" slot="rcd_emname">
              <label class="weui-form-preview__label">{{
                customLabel.rcd_emname || "姓名"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.rcd_emname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="rcd_emcode">
              <label class="weui-form-preview__label">{{
                customLabel.rcd_emcode || "工号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.rcd_emcode
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/repairclass_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout
  },
  data() {
    return {
      baseUrl: "/api/hr/repairClass",
      codeField: "rc_code",
      statusField: "rc_statuscode",
      caller: "HrRepairClass",
      xtype: "hr-repairclass-formpanel",
    };
  }
};
</script>